var _path, _mask;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 6v8.01a1.5 1.5 0 003 0V6A4.5 4.5 0 0030 1.5H6A4.5 4.5 0 001.5 6v24A4.5 4.5 0 006 34.5h9.51a1.5 1.5 0 000-3H6A1.5 1.5 0 014.5 30V6A1.5 1.5 0 016 4.5h24A1.5 1.5 0 0131.5 6zM15 23.25a8.25 8.25 0 0012.926 6.798l4.013 4.013a1.5 1.5 0 002.122-2.122l-4.013-4.013A8.25 8.25 0 1015 23.25zm13.5 0a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z",
    fill: "#777E8C"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "search_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 34,
    height: 34
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 6v8.01a1.5 1.5 0 003 0V6A4.5 4.5 0 0030 1.5H6A4.5 4.5 0 001.5 6v24A4.5 4.5 0 006 34.5h9.51a1.5 1.5 0 000-3H6A1.5 1.5 0 014.5 30V6A1.5 1.5 0 016 4.5h24A1.5 1.5 0 0131.5 6zM15 23.25a8.25 8.25 0 0012.926 6.798l4.013 4.013a1.5 1.5 0 002.122-2.122l-4.013-4.013A8.25 8.25 0 1015 23.25zm13.5 0a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z",
    fill: "#fff"
  }))));
}

export default __webpack_public_path__ + "e9d80355ed4ae70e4658dff12a0e995c.svg";
export { SvgSearch as ReactComponent };